import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import StyledText from '#components/a/StyledText'
import NachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import Avatar from '#components/a/Avatar'
import {routeHelper} from '#config/routeKeys'

export class NachweisFreigebenBenachrichtigungTrainer extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, nachweisId} = this.props
    onNotificationClick(routeHelper.ausbildungsnachweisDetail(nachweisId))
  }

  render() {
    const {userInfo} = this.props
    const text = i18n.t('notification_text_nachweis_freigeben_trainer', [
      `${userInfo.lastname}, ${userInfo.firstname}`,
      this.props.nachweisNummer,
    ])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification nachweis_notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={text} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <NachweisIcon />
        </div>
      </div>
    )
  }
}

NachweisFreigebenBenachrichtigungTrainer.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  nachweisId: PropTypes.string,
  nachweisNummer: PropTypes.number,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(NachweisFreigebenBenachrichtigungTrainer, ['senderId'])
